module.exports = __webpack_public_path__ + "dcadb09331f3ab344210e8d8c5c400d3.svg";